import { Check, X } from "lucide-react";

export default function PasswordStrengthIndicator({ password }) {
  const requirements = [
    { 
      label: "At least 8 characters", 
      test: (p) => p.length >= 8 
    },
    { 
      label: "One uppercase letter", 
      test: (p) => /[A-Z]/.test(p) 
    },
    { 
      label: "One lowercase letter", 
      test: (p) => /[a-z]/.test(p) 
    },
    { 
      label: "One number", 
      test: (p) => /\d/.test(p) 
    },
    { 
      label: "One special character", 
      test: (p) => /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\;'`~]/.test(p) 
    }
  ];

  const passedCount = requirements.filter(req => req.test(password)).length;
  
  // Calculate strength
  let strength = "weak";
  let strengthColor = "bg-red-400";
  let strengthText = "Weak";
  
  if (passedCount >= 5 && password.length >= 8) {
    strength = "strong";
    strengthColor = "bg-[#7A9E7E]";
    strengthText = "Strong";
  } else if (passedCount >= 3) {
    strength = "medium";
    strengthColor = "bg-yellow-500";
    strengthText = "Medium";
  }

  if (!password) return null;

  return (
    <div className="mt-3 space-y-3">
      {/* Strength bar */}
      <div className="space-y-1">
        <div className="flex items-center justify-between text-xs">
          <span className="text-[#6E6A66]">Password strength</span>
          <span className={`font-medium ${
            strength === 'strong' ? 'text-[#7A9E7E]' : 
            strength === 'medium' ? 'text-yellow-600' : 'text-red-500'
          }`}>
            {strengthText}
          </span>
        </div>
        <div className="h-1.5 bg-[#E6E2DD] rounded-full overflow-hidden">
          <div 
            className={`h-full transition-all duration-300 ${strengthColor}`}
            style={{ width: `${(passedCount / 5) * 100}%` }}
          />
        </div>
      </div>

      {/* Requirements list */}
      <div className="space-y-1.5">
        {requirements.map((req, idx) => {
          const passed = req.test(password);
          return (
            <div 
              key={idx} 
              className={`flex items-center gap-2 text-xs transition-colors ${
                passed ? 'text-[#7A9E7E]' : 'text-[#A8A4A0]'
              }`}
            >
              {passed ? (
                <Check className="w-3.5 h-3.5" />
              ) : (
                <X className="w-3.5 h-3.5" />
              )}
              {req.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
